import Ellipsis from './Ellipsis';
export default Ellipsis;
//# sourceMappingURL=index.js.map
